import { render, staticRenderFns } from "./r-trader-config-dropdown.vue?vue&type=template&id=4595a7ce"
import script from "./r-trader-config-dropdown.vue?vue&type=script&lang=js"
export * from "./r-trader-config-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4595a7ce')) {
      api.createRecord('4595a7ce', component.options)
    } else {
      api.reload('4595a7ce', component.options)
    }
    module.hot.accept("./r-trader-config-dropdown.vue?vue&type=template&id=4595a7ce", function () {
      api.rerender('4595a7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-config-dropdown.vue"
export default component.exports